"use client";

import Link from "next/link";

export const BreadcrumbHomepage = () => {
  return (
    <section className="flex w-full flex-row justify-start px-4 pt-8 ph:px-24 md:px-48 lg:px-72 xl:px-96">
      <div className="">
        <Link
          href="/"
          className="inline-flex items-center text-primary transition-colors hover:text-gold"
        >
          <svg
            className="mr-2 h-4 w-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M15 19l-7-7 7-7"
            />
          </svg>
          Retour à l&apos;accueil
        </Link>
      </div>
    </section>
  );
};
